import { EventDate } from './EventDate';
import { BerthCall } from './BerthCall';
import { Port } from './Port';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { IRotationNode } from './IRotationNode';
import { PortCallStatus } from '../../enums/portCallStatus';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';
import { MoveActionMsg } from './ActionMsg';
import { ChemicalRobPortCall } from './TankCleaning/ROB/ChemicalRobPortCall';
import { ChemicalOrderPortCall } from './TankCleaning/Order/ChemicalOrderPortCall';

export class PortCall implements IRotationNode {
    constructor(
        portCallId: number | null,
        berthCallArray: BerthCall[],
        id: number | null,
        voyageNumberPresentationString: string,
        voyageNumber1: string,
        voyageNumber2: string | null,
        name: string | null,
        arrivalDate: EventDate | null,
        departureDate: EventDate | null,
        isSelected: boolean,
        status: PortCallStatus,
        type: RotationTreeEnum,
        port: Port | null,
        timeDeltaInSeconds: number,
        nodeStatus: string,
        isDeleted: boolean,
        isMoved: boolean,
        isMovedTo: boolean,
        isLocked: boolean,
        isInPortCluster: boolean,
        deletedIconTooltipText: string | null,
        aolDate: Date | null,
        reportLocation: ReportLocationEnum,
        isAlreadyIncludedInAPortCluster: boolean,
        imosPortFunction: string | null,
        timezoneWarningText: string | null,
        chemicalRobForPortCall: ChemicalRobPortCall | null,
        chemicalOrderForPortCallList: ChemicalOrderPortCall[],
        portClusterInitialPortId: number | null,
        portClusterInitialPortName: string | null,
        delayInputWarningText: string | null,
        firstTimeInPortCall: Date | null
    ) {
        this.portCallId = portCallId;
        this.berthCallArray = berthCallArray;
        this.rotationTreeEnum = type;
        this.id = id;
        this.voyageNumberPresentationString = voyageNumberPresentationString;
        this.voyageNumber1 = voyageNumber1;
        this.voyageNumber2 = voyageNumber2;
        this.name = name;
        this.arrivalDate = arrivalDate;
        this.departureDate = departureDate;
        this.isSelected = isSelected;
        this.status = status;
        this.type = type;
        this.isDeparted = status === PortCallStatus.Departed;
        this.port = port;
        this.portCall = this;
        this.portCallStatus = status;
        this.timeDeltaInSeconds = timeDeltaInSeconds;
        this.nodeStatus = nodeStatus;
        this.isDeleted = isDeleted;
        this.isMoved = isMoved;
        this.isMovedTo = isMovedTo;
        this.isLocked = isLocked;
        this.isInPortCluster = isInPortCluster;
        this.deletedIconTooltipText = deletedIconTooltipText;
        this.aolDate = aolDate;
        this.reportLocation = reportLocation;
        this.actionMsg = new MoveActionMsg(false, null, false, null, null, null);
        this.isAlreadyIncludedInAPortCluster = isAlreadyIncludedInAPortCluster;
        this.movedFromClicked = false;
        this.imosPortFunction = imosPortFunction;
        this.timezoneWarningText = timezoneWarningText;
        this.chemicalRobForPortCall = chemicalRobForPortCall;
        this.chemicalOrderForPortCallList = chemicalOrderForPortCallList;
        this.portClusterInitialPortId = portClusterInitialPortId;
        this.portClusterInitialPortName = portClusterInitialPortName;
        this.delayInputWarningText = delayInputWarningText;
        this.firstTimeInPortCall = firstTimeInPortCall;
    }
    portCallId: number | null;
    berthCallArray: BerthCall[];
    rotationTreeEnum: RotationTreeEnum;
    id: number | null;
    voyageNumberPresentationString: string;
    voyageNumber1: string;
    voyageNumber2: string | null;
    name: string | null;
    arrivalDate: EventDate | null;
    departureDate: EventDate | null;
    isSelected: boolean;
    status: PortCallStatus;
    type: RotationTreeEnum;
    isDeparted: boolean;
    port: Port | null;
    portCall: PortCall;
    portCallStatus: PortCallStatus;
    timeDeltaInSeconds: number;
    nodeStatus: string;
    isDeleted: boolean;
    isMoved: boolean;
    isMovedTo: boolean;
    actionMsg: MoveActionMsg;
    isLocked: boolean;
    isInPortCluster: boolean;
    deletedIconTooltipText: string | null;
    aolDate: Date | null;
    reportLocation: ReportLocationEnum;
    isAlreadyIncludedInAPortCluster: boolean;
    movedFromClicked: boolean;
    imosPortFunction: string | null;
    timezoneWarningText: string | null;
    chemicalRobForPortCall: ChemicalRobPortCall | null;
    chemicalOrderForPortCallList: ChemicalOrderPortCall[];
    portClusterInitialPortId: number | null;
    portClusterInitialPortName: string | null;
    delayInputWarningText: string | null;
    firstTimeInPortCall: Date | null;
}
